import Flex from 'imports/core/ui/atoms/Flex';
import Head from 'next/head';
import { useRouter } from 'next/router';
import styled, { css } from 'styled-components';
import { useResponsive } from '/imports/core/api/responsiveContext';
import Address from '/imports/core/ui/components/Address';
import { getCompanyNameByHost, getLandingAddress, renderAddress } from '/lib/helpers';
import { CheckoutText } from 'imports/checkout/ui/atoms';

const LegalNameInfo = () => {
  const { host } = useResponsive();
  const { query } = useRouter();
  const { onlyCompany, onlyAdd: onlyAddress, dashboard, isPayment, width = 0, isPaymentMobile } = query;

  const companyName = getCompanyNameByHost(host);
  const addressHtml = renderAddress(host);

  const getData = () => {
    if (host === 'resumizeme') {
      return (
        <>
          <FooterAddress $companyName>{companyName}</FooterAddress>
          <FooterAddress>Address: {getLandingAddress(host)}</FooterAddress>
        </>
      );
    }
    if (onlyCompany && isPayment) {
      return (
        <StyledHelpText width={width} justifyContent="center" $fullWidth>
          {companyName}
        </StyledHelpText>
      );
    }
    if (onlyCompany) {
      return (
        <CompanyName $checkout justifyContent="center" $fullWidth>
          {companyName}
        </CompanyName>
      );
    }
    if (onlyAddress) {
      return <Address forDashboard={dashboard} />;
    }
    if (isPayment) {
      return <StyledHelpText width={width} dangerouslySetInnerHTML={{ __html: addressHtml }} />;
    }
    if (isPaymentMobile) {
      return <MobilePaymentText dangerouslySetInnerHTML={{ __html: addressHtml }} />;
    }
    return (
      <>
        <CompanyName $newDesign justifyContent="center" $fullWidth>
          {companyName}
        </CompanyName>
        <Address />
      </>
    );
  };

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      {getData()}
    </>
  );
};

const MobilePaymentText = styled(CheckoutText)`
  margin-top: 8px;
  font-weight: 500;
  font-size: 10px;
  line-height: 1.2;
  color: #696e79;
  margin: 0;
  a {
    color: #8c9099;
    &:hover {
      text-decoration: none;
    }
  }
`;

const StyledHelpText = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteRegular};
  font-size: 13px;
  line-height: 1.7;
  text-align: left;
  color: #3d4046;
  margin: 0;
  margin-top: 8px;

  ${({ width }) => css`
    ${width < 2300 &&
    css`
      font-size: 12px;
      line-height: 1.2;
      margin-bottom: 14px;
    `}
    ${width < 1366 &&
    css`
      font-size: 9px;
      line-height: 1.2;
      margin-bottom: 11px;
      margin-top: 4px;
    `}
  `}

  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      text-align: right;
    `}
`;

const FooterAddress = styled.div`
  color: #595964;
  text-align: center;
  @media (max-width: 479px) {
    text-align: left;
  }

  ${({ $companyName }) =>
    $companyName &&
    css`
      margin-bottom: 10px;
    `}
`;

const CompanyName = styled(Flex)`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 12px;
  color: #8c8cb7;
  width: 100%;
  padding: 0 35px;
  text-align: center;

  ${({ $isNew, $newDesign, $checkout }) => css`
    ${$checkout &&
    css`
      font-size: 11px;
      color: var(--grayscale-n300) !important;
      font-weight: 500;
      line-height: 14px;
    `}
    ${$isNew &&
    css`
      padding: 0;
      margin: 12px 0 50px;
    `}
    ${$newDesign &&
    css`
      color: var(--neutral-values-gray-light);
    `}
  `}
`;
export default LegalNameInfo;
